import React, { useState, useEffect, useRef } from 'react';

import EditModalShell from '../forms/EditModalShell/EditModalShell';
import FormField from '../forms/FormField/FormField';

import './RateModal.css';

const RateModal = ({ onClose, onSubmit, service, rate, mode }) => {
  const initialFormState = {
    rateId: null,
    name: '',
    price: 0,
    is_hst: false,
  };

  const [formData, setFormData] = useState(initialFormState);
  const { name, price, is_hst } = formData;

  const firstInputRef = useRef();

  useEffect(() => {
    setFormData({
      rateId: rate?._id || null,
      name: rate?.name || '',
      price: rate?.price ?? 0,
      is_hst: rate?.is_hst || false,
    });

    firstInputRef.current?.focus();
  }, [mode, service, rate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: name === 'price' ? Number(value) : value,
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;

    setFormData((prev) => ({ ...prev, [name]: checked }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await onSubmit(formData);
  };

  return (
    <EditModalShell
      formId='rate-modal-form'
      onClose={onClose}
      onSubmit={handleSubmit}
      mode={mode}
      itemLabel='Rate'
      itemSublabel={service.title}
    >
      <FormField
        type='text'
        name='name'
        label='Rate Title'
        autoComplete='off'
        value={name}
        onChange={handleInputChange}
        ref={firstInputRef}
        required
      />
      <FormField
        type='currency'
        name='price'
        label='Rate'
        autoComplete='off'
        value={price}
        onChange={handleInputChange}
      />
      <FormField
        type='checkbox'
        name='is_hst'
        label='+ HST'
        value={is_hst}
        checked={is_hst}
        onChange={handleCheckboxChange}
      />
    </EditModalShell>
  );
};

export default RateModal;
